import React from 'react'
import { Stack } from 'expo-router'

export default function GameLayout() {
  // gestureEnabled:false — swipe-back is disabled app-wide (see app/_layout).
  return (
    <Stack screenOptions={{ headerShown: false, gestureEnabled: false }}>
      {/* Keep the legacy chat path registered so stale links can redirect into
          the game screen; events retains its former bottom-sheet transition. */}
      <Stack.Screen name="chat" options={{ animation: 'none' }} />
      <Stack.Screen name="events" options={{ animation: 'slide_from_bottom' }} />
      {/* Secret 1:1 message thread — same bottom-slide feel as chat. */}
      <Stack.Screen name="dm/[userId]" options={{ animation: 'slide_from_bottom' }} />
      {/* Secret team chat (team games): the same feel as a 1:1 thread. */}
      <Stack.Screen name="dm/team" options={{ animation: 'slide_from_bottom' }} />
    </Stack>
  )
}
